export default __webpack_public_path__ + "static/media/residence-background.756fa8a4.jpg";